import React from "react";

const HeadCell = (title: string) => (
  <h6>
    <small className="font-weight-bold">{title}</small>
  </h6>
);

export default HeadCell;
